import * as React from 'react';

export default class download extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 12 12" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="download-icon" strokeWidth="1" fillRule="evenodd" strokeLinecap="round">
            <g id="Group-136">
                <path d="M6.10547368,0.915830922 L6.10547368,10.0313684" id="Stroke-319"></path>
                <polyline id="Stroke-323" points="2.81269474 6.98147368 6.10553684 10.4564211 9.14637895 7.07810526"></polyline>
                <path d="M0.473684211,11.3684211 L11.7896842,11.3684211" id="base"></path>
            </g>
        </g>
      </svg>
    )
  }
}
